import { createApp } from "vue";
import store from "./store/store";
import AmenityApp from "./components/AmenityApp.vue";

if (document.querySelector('#amenity_app')) {
  const app = createApp(AmenityApp);
  app.use(store)
  app.mount("#amenity_app");
}
